import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import AssignAgentTeamSettingsForm from './AssignAgentTeamSettingsForm';
import i18n from 'i18n';

interface AssignAgentTeamSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeTeamId: number;
}

const AssignAgentTeamSettingsModal: React.FC<AssignAgentTeamSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeTeamId
    }
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_agent_team.text')}
        entityId={activeTeamId}
        entityIdPropName="teamId"
        FormComponent={AssignAgentTeamSettingsForm}
    />
));

AssignAgentTeamSettingsModal.displayName = 'AssignAgentTeamSettingsModal';

export default AssignAgentTeamSettingsModal; 